
    import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
    import Util from '../../../lib/util'
    import AbpBase from '../../../lib/abpbase'
    import appconst from '@/lib/appconst';
    import warehouseCity from '@/store/entities/warehouse-city';
    import warehouseInfo from '@/store/entities/warehouseInfo';
    import Enums from '@/lib/enums'
    import user from '@/store/entities/userinfo'
    class EditOrderModel {
        id: number;
        warehouseInfoId: number;
        cargoCategory: number = 0;
        isSend: boolean = false;
        weight: number=0;
        long: number=0;
        wide: number=0;
        high: number=0;
        mainLandInterNationalShipment: string = "";
        appointUserId: number;
    }
    @Component
    export default class EditPackage extends AbpBase {
        @Prop({ type: Boolean, default: false }) value: boolean;
        EditModel: EditOrderModel = new EditOrderModel();
        cargoCategoryType = Enums.CargoCategoryType;
        addLoding = false;
        warehouseCityId: number = 0;
        warehouseCityList: Array<warehouseCity> = [];
        warehouseInfoList: Array<warehouseInfo> = [];
        returnsTimeVal: string = "";
        user: Array<user> = [];
        async edit() {

            this.addLoding = true;
            await this.$store.dispatch({
                type: 'mainlandpackage/editMainLandPackage',
                data: this.EditModel
            }).finally(() => {
                this.addLoding = false;
            });
            (this.$refs.editForm as any).resetFields();
            this.$emit('save-success');
            this.$emit('input', false);

        }
        created() {
            this.getCity();
            this.getUser();
        }
        async getUser() {
            this.user = await this.$store.dispatch({
                type: 'user/getUserList',
                data: {}
            });
            if (this.user.length > 0) {
                var data = this.user.filter(function (item) { return item.id == abp.session.userId });
                if (data.length > 0) {
                    this.EditModel.appointUserId = data[0].id;
                }
            }

        }
        cancel() {
            (this.$refs.editForm as any).resetFields();
            this.$emit('input', false);
        }
        async changeWarehouseCity(val: number) {
            this.warehouseInfoList = await this.$store.dispatch({
                type: 'warehouseInfo/get',
                data: { CityId: val }
            });
            if (this.warehouseInfoList.length == 1) {
                this.EditModel.warehouseInfoId = this.warehouseInfoList[0].id;
            }
        }
        async getCity() {
            this.warehouseCityList = await this.$store.dispatch({
                type: 'warehouseCity/get',
                data: {}
            });
            if (this.warehouseCityList.length > 0) {
                this.warehouseCityId = this.warehouseCityList[0].id;
                this.changeWarehouseCity(this.warehouseCityId);
            }
        }

        visibleChange(value: boolean) {
            if (!value) {
                this.$emit('input', value);
            } else {
                (this.$refs.editForm as any).resetFields();
                var data = this.$store.state.mainlandpackage.MainLandPackageList;
                this.EditModel.id = data.id;
                this.EditModel.warehouseInfoId = data.warehouseInfoId;
                this.EditModel.mainLandInterNationalShipment = data.mainLandInterNationalShipment;
                //this.EditModel.long = data.long;
                //this.EditModel.wide = data.wide;
                //this.EditModel.high = data.high;
                //this.EditModel.isSend = data.isSend;
                //this.EditModel.weight = data.weight;
                this.EditModel.cargoCategory = data.cargoCategory;
                this.EditModel.appointUserId = data.appointUserId;
            }
        }

    }
